
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as FileXlsIconComponent } from "./file-xls-icon.svg";

export const FileXlsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <FileXlsIconComponent {...props} />;
};
